import styles from './styles.module.css';
import Modal from 'react-responsive-modal';
import { Button } from '../../../Button';

interface IModalContactUs {
  modalIsOpen: boolean;
  closeModal: () => void;
}

export function ModalInfoContactUs({
  modalIsOpen,
  closeModal,
}: IModalContactUs) {
  return (
    <Modal open={modalIsOpen} onClose={closeModal} center>
      <>
        <div className="contents-modal">
          <h2 className="title-modal">Mensagem enviada com sucesso!</h2>
          <p className="subtitle-modal">Em breve entraremos em contato.</p>
        </div>
        <div className={styles.contentBtn}>
          <Button
            isModal
            text="Entendido"
            type="button"
            color="primary"
            onClick={closeModal}
          />
        </div>
      </>
    </Modal>
  );
}
